<template>
  <button
    :class="[hasBorder ? '' : 'border border-solid border-white']"
    class="btn bg-primary text-white rounded-full text-center"
  >{{ name }}</button>
</template>

<script>
export default {
  props: ["name", "hasBorder"]
};
</script>

<style scoped>
.btn {
  min-width: 174px;
  height: 42px;
  padding-left: 16px;
  padding-right: 16px;
}

.btn:hover {
  background-color: #094a4a;
}
</style>